"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getLegacyNetworkTypes() {
    return ["quorum", "fabric-evm"];
}
exports.getLegacyNetworkTypes = getLegacyNetworkTypes;
;
var web3_shim_1 = require("./web3-shim");
exports.Web3Shim = web3_shim_1.Web3Shim;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./packages/truffle-interface-adapter/dist/index.js
// module id = 144
// module chunks = 0 1 3